export default "__VITE_ASSET__kLTDzqTJ__"